export default __webpack_public_path__ + "static/media/assistant-welcome-1.abf031c8.png";